import { render, staticRenderFns } from "./DeleteCommunityPayment.vue?vue&type=template&id=ce609808&scoped=true"
import script from "./DeleteCommunityPayment.vue?vue&type=script&lang=js"
export * from "./DeleteCommunityPayment.vue?vue&type=script&lang=js"
import style0 from "./DeleteCommunityPayment.vue?vue&type=style&index=0&id=ce609808&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce609808",
  null
  
)

export default component.exports